import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import type { DailyUtilisation } from '@/types/utilisation';

interface UtilisationOverviewProps {
  dailyUtilisation: DailyUtilisation[];
}

export const UtilisationOverview: React.FC<UtilisationOverviewProps> = ({
  dailyUtilisation,
}) => {
  return (
    <Card>
        <CardHeader>
          <CardTitle className="text-base">Daily Utilisation Rate</CardTitle>
          <CardDescription>Utilisation percentage by day</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-2">
            {dailyUtilisation.map((day, index) => (
              <div 
                key={day.day} 
                className={cn(
                  "p-3 rounded-lg hover:bg-muted/50 transition-colors cursor-pointer",
                  index !== dailyUtilisation.length - 1 && "border-b"
                )}
              >
                <div className="flex items-center justify-between mb-2">
                  <span className="font-medium capitalize">{day.day}</span>
                  <span className={cn(
                    "text-sm font-semibold",
                    day.utilisationRate >= 0.75
                      ? 'text-success-500'
                      : day.utilisationRate >= 0.5
                        ? 'text-warning-500'
                        : 'text-error-500'
                  )}>
                    {(day.utilisationRate * 100).toFixed(0)}%
                  </span>
                </div>
                <div className="h-2 bg-muted rounded-full overflow-hidden mb-2">
                  <div
                    className={cn(
                      'h-full transition-all',
                      day.utilisationRate >= 0.75
                        ? 'bg-success-500'
                        : day.utilisationRate >= 0.5
                          ? 'bg-warning-500'
                          : 'bg-error-500'
                    )}
                    style={{ width: `${day.utilisationRate * 100}%` }}
                  />
                </div>
                <div className="grid grid-cols-2 gap-2 text-xs">
                  <div>
                    <span className="text-muted-foreground">Total:</span>
                    <span className="ml-1 font-medium">{day.totalHours.toFixed(1)}h</span>
                  </div>
                  <div>
                    <span className="text-muted-foreground">Billable:</span>
                    <span className="ml-1 font-medium">{day.billableHours.toFixed(1)}h</span>
                  </div>
                  <div className="col-span-2">
                    <span className="text-muted-foreground">Non-billable:</span>
                    <span className="ml-1 font-medium">{day.nonBillableHours.toFixed(1)}h</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
  );
};
